import { API2_HOST } from '@/utils/constants';

import fetchData from '../http';

/**
 * 查询导出记录
 */
export function post__v3_private_cht_asset_file_core_export_list(params?: any) {
  return fetchData.post<any>(
    `${API2_HOST}/v3/private/cht/asset-file-core/export/list`,
    {
      body: JSON.stringify(params),
    },
  );
}

/**
 * 查询文件下载地址
 * int64 id = 1;
 */
export function post__v3_private_cht_asset_file_core_export_url(params?: any) {
  return fetchData.post<any>(
    `${API2_HOST}/v3/private/cht/asset-file-core/export/url`,
    {
      body: JSON.stringify(params),
    },
  );
}

/**
 * 获取可导出类型
 * string group = 1; // 分组id
 */
export function post__v3_private_cht_asset_file_core_export_config(
  params?: any,
) {
  return fetchData.post<any>(
    `${API2_HOST}/v3/private/cht/asset-file-core/export/config`,
    {
      body: JSON.stringify(params),
    },
  );
}

/**
 * 提交导出请求
  int64 end_times = 3; // 截止时间
 */
export function post__v3_private_cht_asset_file_core_export_create_account_statement(
  params?: any,
) {
  return fetchData.post<any>(
    `${API2_HOST}/v3/private/cht/asset-file-core/export/create/account-statement`,
    {
      body: JSON.stringify(params),
    },
  );
}
